import { Login } from './login'

Login.define('fp-login')

declare global {
  interface HTMLElementTagNameMap {
    'fp-login': Login;
  }
}
export default Login 